module.exports = __webpack_public_path__ + "static/RobbiePallas_CV-29141728437e8740618e94ac752aa472.pdf";